import React from 'react';
import './About.Css';

const About = () => {
    return (
        <div className="container w-50 mx-auto my-5">
            <h2>Assalamualaikum...I am Lamia Mostafa</h2>
            <p className="alignment">My biggest goal in this 2022 is to become a junior web developer.</p>
            <p className="alignment">I worked very hard for it.Whenever I get free time I make my time to learn somthing new in this sector. I give everyday a minimum amount of time to learn it properly. I believe the word that <b>a small effort can change everything .</b> So, I try a lot to do as much as I can do. It is also true that I get Stuck maximum of the time. I have also lots of problems.Sometimes I can not understand a simple logic. Then I try to google it or asked some of my seniors or sometimes I take a break and take some fresh air.Then  after a couple of times I can  understand the topic. I love the way of learning in programming.Programming is like my best friend now.    </p>
        </div>
    );
};

export default About;